import React, { useEffect, useState } from 'react';
import useApiControl from './common/useApiControl';
import LoginForm from './components/forms/LoginForm';
import Room from './Room';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import NotLoginHeader from './components/headers/NotLoginHeader';

const Login = ({ afterLogin, room_id } = {}) => {
  console.log('login rendered');

  const { data, loading, executeRequest } = useApiControl({
    action: '/is_login',
    method: 'POST',
  });
  const [unauthorized, setUnauthorized] = useState(false);
  const [exceptionOccurred, setExceptionOccurred] = useState(false);

  useEffect(() => {
    executeRequest().catch((error) => {
      if (error.response && error.response.status === 401) {
        setUnauthorized(true);
      } else {
        console.error(error);
        setExceptionOccurred(true);
      }
    });
  }, [executeRequest]);

  // APIからのレスポンスがまだない場合、またはエラーが発生した場合（401以外）は何も表示しない
  if (loading || exceptionOccurred) {
    return null;
  }

  // ログインしている場合はRoomを表示
  if (data && data.is_login && !unauthorized) {
    return (
      <Room page="member" />
    );
  }

  // ログインしていない場合、または401エラーが発生した場合は、ログインフォームのみを表示
  return (
    <>
      <NotLoginHeader />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
        minHeight="calc(100vh - 50px)" // ヘッダー分を引いた高さを確保
      >
        <LoginForm afterLogin={afterLogin} room_id={room_id} />
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            アカウントをお持ちでない方はこちら
          </Typography>
          <Button href="/register" variant="outlined">
            新規登録
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Login;
